import axios from "axios";

const backendUrl = (process.env.REACT_APP_BACKEND_URL || "").replace(/\/$/, "");

const api = axios.create({
  baseURL: backendUrl ? `${backendUrl}/api` : "/api",
  timeout: Number(process.env.REACT_APP_API_TIMEOUT || 30000),
});

api.interceptors.request.use((config) => {
  const token = localStorage.getItem("sprintai_token");
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

api.interceptors.response.use(
  (res) => res,
  (error) => {
    if (error.response?.status === 401) {
      localStorage.removeItem("sprintai_token");
      localStorage.removeItem("sprintai_user");
      window.location.href = "/login";
    }
    return Promise.reject(error);
  }
);

export default api;
